import React from "react";
import SpeechSynthesis from "./SpeechSynthesis";

import { Correct, Wrong } from "../../assets/svg/icons";

import { GameContext } from "../../context/GameContext";

import useResponsive from "../../hooks/useResponsive";

const CardBackFace = ({ nextQuestion }) => {
  const {
    setCurrentQuestion,
    currentQuestion,
    selected,
    questionsArray,
    isFlipped,
    setIsFlipped,
    setView,
    setDeskQuest,
  } = React.useContext(GameContext);
  const { Mobile, Default } = useResponsive();

  var res = questionsArray.find((obj) => {
    return obj.id === currentQuestion;
  });

  const handleClick = (e) => {
    if (e.target.name === "result") {
      setView("result");
    } else if (e.target.name === "previous") {
      setIsFlipped(!isFlipped);
      setCurrentQuestion(currentQuestion - 1);
      nextQuestion(currentQuestion - 1);
      return;
    }
    setIsFlipped(!isFlipped);
    setCurrentQuestion(currentQuestion + 1);
    nextQuestion(currentQuestion + 1);
  };

  var speak =
    (res.answers[selected].correct ? "Ja!" : "Nej!") +
    " " +
    res.answers[selected].text;

  return (
    <div className="back-content">
      {res.answers[selected].correct ? <Correct /> : <Wrong />}
      <SpeechSynthesis text={speak} />
      <p className="card-answer_title">
        {res.answers[selected].correct ? "Ja!" : "Nej!"}
      </p>
      <p className="card-answer_text">{res.answers[selected].text}</p>
      <Default>
        <button
          className="active_button"
          name="next"
          onClick={() => {
            setIsFlipped(!isFlipped);
            setCurrentQuestion(currentQuestion + 1);
            nextQuestion(currentQuestion + 1);
            setDeskQuest(false);
          }}
          aria-label="Gå till nästa fråga"
        >
          <Default>Välj ny figur från bilden</Default>
        </button>
      </Default>
      <Mobile>
        {questionsArray.length - 1 === currentQuestion ? (
          <button
            className="active_button"
            name="previous"
            onClick={handleClick}
            aria-label="Gå till föregående fråga"
          >
            Föregående fråga
          </button>
        ) : (
          <button
            className="active_button"
            name="next"
            onClick={handleClick}
            aria-label="Gå till nästa fråga"
          >
            Nästa fråga
          </button>
        )}
        {questionsArray.length - 1 === currentQuestion && (
          <button
            className="active_button"
            name="result"
            onClick={handleClick}
            aria-label="Se ditt resultat"
          >
            Se resultat
          </button>
        )}
      </Mobile>
    </div>
  );
};

export default CardBackFace;
